'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DYNAMIC_EVENT_DURATION_SUFFIX = exports.DYNAMIC_EVENT_DURATION_SUFFIX = '_intervalDuration';
var DYNAMIC_EVENT_FAILED_SUFFIX = exports.DYNAMIC_EVENT_FAILED_SUFFIX = '_intervalFailed';
var DYNAMIC_EVENT_END_SUFFIX = exports.DYNAMIC_EVENT_END_SUFFIX = '_intervalEnded';
var DYNAMIC_EVENT_END_NAME = exports.DYNAMIC_EVENT_END_NAME = 'profileIntervalDidEnd';
var DYNAMIC_EVENT_END_SUFFIXES_REGEX = exports.DYNAMIC_EVENT_END_SUFFIXES_REGEX = new RegExp('(' + [DYNAMIC_EVENT_DURATION_SUFFIX, DYNAMIC_EVENT_FAILED_SUFFIX, DYNAMIC_EVENT_END_SUFFIX].join('|') + ')$');
var DYNAMIC_EVENT_BUBBLES = exports.DYNAMIC_EVENT_BUBBLES = true;
var DYNAMIC_EVENT_CANCELABLE = exports.DYNAMIC_EVENT_CANCELABLE = true;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/constants.js
// module id = 416
// module chunks = 5